module.exports = __webpack_public_path__ + "static/img/TOM_MOODY.e076b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOM_MOODY.jpg
// module id = 2kAy
// module chunks = 0